@if(loader){
  <app-loader></app-loader>
  }
<p-card header="">
  <div class="">
       <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
        <div class="flex align-items-center">
          <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" (click)="createUser()" size="small"
            pTooltip="Create User Information"></p-button>
      
          <div class="flex align-items-center ml-3">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class=" p-inputtext-sm"
                (keyup.enter)="searchuser()" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;"/>
            </span> 
            <p-button icon="pi pi-search" (onClick)="searchuser()" class="ml-2"
                [ngStyle]="{ height: '35px' }" [raised]="true"
                [size]="'small'" severity="info"></p-button>
          </div>
           <p-button *ngIf="selecteduser && selecteduser.length == 1" label="Edit" class="ml-2" icon="pi pi-user-edit"
            (click)="updateUser()" size="small" severity="secondary"></p-button>
          <p-button *ngIf="selecteduser && selecteduser.length > 0" label="Delete" class="ml-2" icon="pi pi-trash"
            (click)="deleteUser()" size="small" severity="danger"></p-button>
        </div>
        <h2 class="page-title-center">User List</h2>

        <div class="flex">
          <div class="flex align-items-center">
            <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true" severity="info"></p-button>
          </div>
        </div>
      </div>




          <p-table #dt1 [value]="userList" [scrollable]="true" scrollHeight="650px" (onPage)="load($event)"
          styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm"
          [paginator]="true" [rows]="10" [selectionPageOnly]="true"
          [(selection)]="selecteduser" [globalFilterFields]="['username']"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="[10,15,20]">
          <ng-template pTemplate="header">
             <tr>
                 <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                 <th>User Name</th>
                 <th>First Name</th>
                 <th>Last Name</th>
                 <th>Email</th>
                 <!-- <th>Created By</th> -->
                 <th>Last Logon</th>
                 <th>Logoff</th>
                 <th>Logged In</th>
                 <th>Active</th>
             </tr>
         </ng-template>
         <ng-template pTemplate="body" let-user>
             <tr>
                 <td>
                    <p-tableCheckbox [value]="user"></p-tableCheckbox>
                 </td>
                 <td class="text-blue-500 underline" style="cursor: pointer;" (click)="updateUser(user.userId)">
                  {{user. username}}</td>
                 <!-- <td>{{user.username}}</td> -->
                 <td>{{user.firstName}}</td>
                 <td>{{user.lastName}}</td>
                 <td>{{user.email}}</td>
                 <!-- <td>{{user.createdBy}}</td> -->
                 <td>{{ user.lastLogon ? (user.lastLogon | date: 'dd/MM/yyyy h:mm:ss a') : '-' }}</td>
                 <td>{{ user.lastLogoff ? (user.lastLogoff | date:'dd/MM/yyyy h:mm:ss a') : '-' }}</td>
                 <td class="{{ user.isLoggedIn ? 'active' : 'inactive' }}">
                 {{ user.isLoggedIn ? 'Y' : 'N' }}
                 </td>
                 <td class="{{ user.isActive ? 'active' : 'inactive' }}">
                  {{ user.isActive ? 'Yes' : 'No' }}
                </td>             </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">No Records found.</td>
                </tr>
            </ng-template>
          </p-table>
        </div>
        </p-card>

    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>
